import { isValidElement, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'
import clsx from 'clsx'
import { convertJsxToString } from '../../../../../shared/component-helper'
import { Flex } from '../../../../../components'
import type { FlexContainerAllProps as FlexContainerProps } from '../../../../../components/flex/Container'
import { Lead } from '../../../../../elements'
import Toolbar from '../Toolbar/Toolbar'
import type { SectionContainerProps } from '../containers/SectionContainer'
import SectionContainer from '../containers/SectionContainer'
import EditButton from './EditButton'
import SectionContainerContext from '../containers/SectionContainerContext'
import withComponentMarkers from '../../../../../shared/helpers/withComponentMarkers'

export type FormSectionViewContainerProps = {
  title?: ReactNode
  onEdit?: () => void
}

export type FormSectionViewContainerAllProps =
  FormSectionViewContainerProps &
    SectionContainerProps &
    FlexContainerProps

function ViewContainer(props: FormSectionViewContainerAllProps) {
  const { children, className, title, onEdit, ...restProps } = props || {}
  const ariaLabel = useMemo(() => convertJsxToString(title), [title])
  const { disableEditing } = useContext(SectionContainerContext) || {}

  const childArray = Array.isArray(children) ? children : [children]
  const hasToolbar = childArray.some(
    (child) => isValidElement(child) && child.type === Toolbar
  )

  const showDefaultToolbar = !disableEditing && !hasToolbar

  return (
    <SectionContainer
      mode="view"
      ariaLabel={ariaLabel}
      className={clsx('dnb-forms-section-view-block', className)}
      {...restProps}
    >
      <Flex.Stack>
        {title && <Lead size="basis">{title}</Lead>}
        {children}
        {showDefaultToolbar ? (
          <Toolbar onEdit={onEdit}>
            <EditButton />
          </Toolbar>
        ) : null}
      </Flex.Stack>
    </SectionContainer>
  )
}
ViewContainer.EditButton = EditButton

withComponentMarkers(ViewContainer, {
  _supportsSpacingProps: true,
})

export default ViewContainer
